/*
 * <alto-rotator> — cycles its children every `data-interval` ms (default 3000)
 * using the slide transition defined for `.alto-rotator` in tailwind.css.
 *
 * A custom element so cards injected later (pagination, filters, section
 * rendering) start rotating on their own, and timers are cleared on removal.
 */

class AltoRotator extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    if (!this.items.length) return;

    this.current = Math.max(
      this.items.findIndex((item) => item.classList.contains('is-active')),
      0
    );
    this.items[this.current].classList.add('is-active');

    if (this.items.length < 2) return;
    const interval = parseInt(this.dataset.interval, 10) || 3000;
    this.timer = setInterval(() => this.go((this.current + 1) % this.items.length), interval);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  go(next) {
    this.items.forEach((item, idx) => {
      if (idx === this.current && idx !== next) {
        // The active item slides down and out
        item.classList.remove('is-active');
        item.classList.add('is-exiting');
      } else if (idx !== next) {
        // Park instantly above (base rule has no transition)
        item.classList.remove('is-active', 'is-exiting');
      }
    });
    const incoming = this.items[next];
    incoming.classList.remove('is-active', 'is-exiting'); // snap to -100%
    void incoming.offsetWidth; // flush the snap so it doesn't animate
    incoming.classList.add('is-active'); // slide in from the top
    this.current = next;
  }
}

if (!customElements.get('alto-rotator')) {
  customElements.define('alto-rotator', AltoRotator);
}
